

import './BookingsFilterComponent.scss'
import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import HotelInfo from '../../../models/HotelInfo';
import StatusInfo from '../../../models/StatusInfo';
import UsersInfo, { GetUserAccountsResponseData } from '../../../models/UsersInfo';
import { BookingFilteData } from '../../../models/BookingInfo';
import { useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

interface BookingsFilterComponentProps {
    hotelList: HotelInfo[],
    statusList: StatusInfo[],
    userList: GetUserAccountsResponseData[],
    onFilter: (filter: BookingFilteData) => void
    loading : boolean
}

const BookingsFilterComponent = (props: BookingsFilterComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const onFinish = () => {
        props.onFilter(form.getFieldsValue());
    }

    // Busca el usuario por nombre y apellidos sin tener en cuenta mayúsculas ni acentos
    const normalizeText = (value: string): string => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const filterUser = (input: string, option?: { label?: unknown }): boolean => normalizeText(String(option?.label ?? "")).includes(normalizeText(input));

    return (
        <div className="bookings-filter">
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Row gutter={16}>
                    <Col xs={24} lg={8}>
                        <Form.Item name="locator" label={t('components.bookings-filter.form.locator')}>
                            <Input type="text" className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="hotelId" label="Hotel" initialValue={""}>
                            <Select >
                                <Select.Option value="">{t('components.bookings-filter.form.all')}</Select.Option>
                                {
                                    props.hotelList.map((hotel: HotelInfo, index: number) => {
                                        return <Select.Option value={hotel.id} key={index}>{hotel.name}</Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="ownerName" label={t('components.bookings-filter.form.owner')}>
                            <Input type="text" className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="checkIn" label={t('components.bookings-filter.form.checkIn')}>
                            <DatePicker className="app-input" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="checkOut" label={t('components.bookings-filter.form.checkOut')}>
                            <DatePicker className="app-input" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="status" label={t('components.bookings-filter.form.status')} initialValue={""}>
                            <Select >
                                <Select.Option value="">{t('components.bookings-filter.form.all')}</Select.Option>
                                {
                                    props.statusList.map((status: StatusInfo, index: number) => {
                                        return <Select.Option value={status.name} key={index}>{`${t(`booking-status.${status.name}`)}`}</Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                        <Form.Item name="recordDate" label={t('components.bookings-filter.form.record-date')}>
                            <DatePicker className="app-input" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} lg={8}>
                        <Form.Item name="userId" label={t('components.bookings-filter.form.record-by')} initialValue={""}>
                            <Select showSearch filterOption={filterUser}>
                                <Select.Option value="" label={t('components.bookings-filter.form.all')}>{t('components.bookings-filter.form.all')}</Select.Option>
                                {
                                    props.userList.map((user: GetUserAccountsResponseData, index: number) => {
                                        const label = `${user.surname} ${user.secondSurname}, ${user.name}`;
                                        return <Select.Option value={user.id} key={index} label={label}>{label}</Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} className="btn-actions">
                        <Button htmlType='submit' className="app-button search-button" disabled={props.loading} >
                            {props.loading ? (
                                <>
                                    <LoadingOutlined /> {t('components.bookings-filter.searching')}
                                </>
                            ) : (
                                t('components.bookings-filter.search')
                            )}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default BookingsFilterComponent;